import getApiClient from '@/plugins/api-client'
import planPeriodicities from '@/util/planPeriodicities'
import { parseFilters } from '@/util/helpers'

export default {
  loadPlans () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('plans', { params })
      .then(result => {
        this.plans = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  getPlanPeriodicityLabel (periodicity) {
    return planPeriodicities.filter(item => {
      return item.code === periodicity
    })[0]?.label
  },

  clearFilters () {
    this.filters = {}
    this.loadPlans()
  },
}
